import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "./MainContainer";

/** Keeps sidebar/nav visible while a lazy route chunk loads (no white flash). */
export default function RouteFallback() {
    const loggedIn = useSelector((state) => state.loggedReducer);

    if (!loggedIn) {
        return (
            <div
                className="d-flex align-items-center justify-content-center"
                style={{ minHeight: "100vh" }}
                aria-busy="true"
            >
                <div className="spinner-animation" />
            </div>
        );
    }

    return (
        <MainContainer>
            <div className="pt-5 px-4" aria-busy="true" aria-live="polite">
                <div className="skeleton-loading mb-3" style={{ height: 28, width: 220, borderRadius: 6 }} />
                <div className="skeleton-loading mb-2" style={{ height: 14, width: "55%", borderRadius: 4 }} />
                <div className="skeleton-loading mb-4" style={{ height: 14, width: "40%", borderRadius: 4 }} />
                <div className="skeleton-loading" style={{ height: 320, width: "100%", borderRadius: 8 }} />
            </div>
        </MainContainer>
    );
}
